import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';
import { ElementActions } from '../actions/element';
import { ElementTypeActions } from '../actions/elementType';
import { RelationshipTypeActions } from '../actions/relationshipType';

// const projectActions = getActionIds(ProjectActions);
const elementActions = getActionIds(ElementActions);
const elementTypeActions = getActionIds(ElementTypeActions);
const relationshipTypeActions = getActionIds(RelationshipTypeActions);

const initialState = Immutable.fromJS({
  elements: {},
  elementTypes: {},
  relationshipTypes: {},
});

const notFoundHandler = (type, state, action) => {
  if (action.error.json && action.error.json.errors[0] === 'Not Found') {
    const id = action.args[0];
    return state.merge({
      [type]: {
        [id]: true,
      },
    });
  }
  return state;
};

export const notFound = createStore(initialState, {
  [elementActions.getElement.failure]: (state, action) =>
    notFoundHandler('elements', state, action),
  [elementTypeActions.getElementType.failure]: (state, action) =>
    notFoundHandler('elementTypes', state, action),
  [relationshipTypeActions.getRelationshipType.failure]: (state, action) =>
    notFoundHandler('relationshipTypes', state, action),
});

export const notFoundSelector = state => state.notFound;

export const isNotFound = (notFoundState, type, currentId) => {
  return notFoundState.hasIn([type, currentId]);
};



// WEBPACK FOOTER //
// ./src/reducers/notFound.js